/*******************************************************************************
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  *  Copyright © 2021 Pearson Education, Inc.
 *  *  All Rights Reserved.
 *  *
 *  * NOTICE:  All information contained herein is, and remains
 *  * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 *  * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 *  * patent applications, and are protected by trade secret or copyright law.
 *  * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 ******************************************************************************/


import React, { Component } from 'react';
import style from '../../component/common/style/index.scss';
import questionConfig, { GenerateCustomColumn,convertColumndef, convertRowData} from '../../common/tableConfig/questionConfig';
import gridConfig from '../../common/tableConfig/gridConfig';
import asyncCallHandler from '../../common/utils/asyncCallHandler'
import IsNoBlind from './IsNoBlind';
import IsBlind from './Isblind';
import EDW_CONST from '../../common/constants';
import { EdwLoaderWithContainer } from '../common/edwLoaderWithContainer/EdwLoaderWithContainer'
import { ErrorData } from "../common/noData/NoData";

export class QuestionAnalysis extends React.Component {
  constructor(props) {
        super();
    this.state = {
      coloumnDef: [],
      rowData: [],
      icons: gridConfig.icons,
      defaultColDef: gridConfig.defaultColDef  ,
      height: props.height,
      isColorblind: props.isColorblind,
      isDataExist: props.isDataExist,
      questionConfig: questionConfig,
      defaultColumns: [],
      customColumn: [],
      viewBy: 'mark',
      isDataFetch: false,
      pinnedTopRow: [],
      IsApiFail:false,
                isDataLoad:true};
        this.colorBlindview = this.colorBlindview.bind(this);
    this.iesToken = props.token ? props.token : ''
  }
  componentDidMount() {                           
        this.fetchQuestionAnalysis();
  }
  fetchQuestionAnalysis() {
    let questiondata = { ...this.state.questionConfig }
        let {assessmentId, groupId, schoolId, dateTaken, studentYear} = this.props;
    this.setState({ isDataFetch: false })
        asyncCallHandler(EDW_CONST.ASSESSMENT_END_POINT, `questionDetails?assessmentId=${assessmentId}&groupId=${groupId}&examDate=${dateTaken}&schoolId=${schoolId}&studentYear=${studentYear}`, this.iesToken).then(response => {
           
        if (response.data.length > 0) {
			const questionGradeScale = response.data[0]['questionGradeScale']
		    const yearTypeQuestionGradeScaleCount = questionGradeScale.filter(
				(it) => {
				  return it.gradeKey.toLowerCase() === 'yearaverage'
				}
		    ).length
			questiondata['questionGradeScale'] = questionGradeScale.filter(
				(it) => {
				    return (
					    yearTypeQuestionGradeScaleCount <= 1 ||
					    it.gradeKey.toLowerCase() !== 'yearaverage'
				    )
				}
			)
      questiondata['duplicateYearError'] = yearTypeQuestionGradeScaleCount > 1
			questiondata["questionData"] = response.data[0]['questionData'];
			questiondata["questionDescription"] = response.data[0]['questionDescription'];
			questiondata["defaultColumns"] = response.data[0]['defaultColumns'];
			questiondata["icons"] = gridConfig.icons;
			this.generateGridConfig(questiondata, this.state.isColorblind, this.state.viewBy)
        } else {
          this.setState({ isDataLoad: false })
        }
           
        }).catch((error) => {
            console.log("axios error:", error);
            this.setState({ IsApiFail:true})
        });   
  }
  generateGridConfig(questionConfig, isColorblind, viewBy) {
         let customColumns = GenerateCustomColumn(questionConfig, this.state.viewBy);
         let columndef = convertColumndef(false, viewBy, questionConfig, customColumns);
         let rowData = convertRowData(isColorblind, questionConfig);
         let height = 70 + (parseInt(rowData.rowsArray.length) + parseInt(rowData.pinnedTopRow.length)) * 50;
         this.setState({ rowData: rowData.rowsArray, pinnedTopRow: rowData.pinnedTopRow, coloumnDef: columndef, isDataFetch: true, questionConfig: questionConfig, customColumn: customColumns, height: height });  
         this.props.updateExportData({ type: "quesiton_widget_2", rowData: rowData, columnDefs: columndef });      
  }
  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.groupId !== prevProps.groupId ||
      this.props.studentYear !== prevProps.studentYear
    ) {
            this.fetchQuestionAnalysis();
    }
  }

  onCellClicked(event) {
    // console.log(event)
  }
  colorBlindview = (event) => {
        
    if (event.target.checked == true) {
           this.setState({ isColorblind: true });           
    } else {
            this.setState({ isColorblind: false });
    }
  }

  isBlindView(tableConfig) {
        return <div className="question-table"><IsBlind {...tableConfig} courseName={this.props.courseName} /></div>;
  }
  isNoBlindView(tableConfig) {
        return <div className="question-table"><IsNoBlind {...tableConfig} courseName={this.props.courseName} /></div>;
  }
 
   onColumnResized=(params)=> {
      this.gridApi = params.api;
         this.gridApi.resetRowHeights();
  }

    
  render() {
    let tableConfig = {
      questionConfig: this.state.questionConfig,
      height: this.state.height,
      viewBy: this.state.viewBy,
      customColumn: this.state.customColumn,
      isDataExist: this.state.isDataExist,
      isColorblind: this.state.isColorblind,
      colorBlindview: this.colorBlindview,
      rowData: this.state.rowData,
      coloumnDef: this.state.coloumnDef,
      pinnedTopRow: this.state.pinnedTopRow,
      onColumnResized: this.onColumnResized ,
      defaultColDef: this.state.defaultColDef,
      updateExportData: this.props.updateExportData        
    }

        let loadView = <div className="edw-full-width"><EdwLoaderWithContainer/> </div>

    return (
      <div>
                <label><span className="card-title">Question analysis </span></label>
                <div className="col">
                    <div className="row contentFilter content-row-padding">
                        <div className="col-md-6"></div>
                       
                        {/* <div className="col-md-6">
                                <button className="Button download-btn btn-font"><span className={style.iconGeneralDownload}></span>Download student assessment report</button>
            </div> */}
          </div>
        </div>
                    {
          this.state.isDataLoad && !this.state.IsApiFail ?(

          this.state.isColorblind ? (
                                this.state.isDataFetch ? (this.isBlindView(tableConfig)) : loadView
            ) : (
                                this.state.isDataFetch ? (this.isNoBlindView(tableConfig)) : loadView
            )
          ) : (
              <ErrorData/>
          )
                       
                    }
           
      </div>

    )
  }
}